import type { BrandStack, OnboardingBrand } from "../../types/onboarding";
import { CRM_LABELS, HELPDESK_LABELS, REFUND_PLATFORM_LABELS, SUBSCRIPTION_APP_LABELS } from "./labels";

export const EMPTY_STACK: BrandStack = { crms: [], subscriptionApps: [], helpdesks: [], refundsIn: [] };

// Only brands that get steps answer the stack: every brand of a new client, and the brands an existing company
// adds or has nothing connected on yet.
export const findStackBrandIndexes = (brands: OnboardingBrand[]): number[] => brands.flatMap((b, i) => (b.isNew ? [i] : []));

const toNames = <T extends string>(list: T[], labels: Record<T, string>, otherName: string | undefined) =>
  list.filter((v) => v !== "none").map((v) => (v === "other" ? otherName?.trim() || labels[v] : labels[v]));

// "Shopify · Loop · Zendesk · refunds in Shopify"; empty when nothing is picked.
export function toStackSummary(stack: BrandStack): string {
  const apps = toNames(stack.subscriptionApps, SUBSCRIPTION_APP_LABELS, stack.otherSubscriptionAppName)
    .map((name) => (name === SUBSCRIPTION_APP_LABELS.checkoutchamp ? "CheckoutChamp app" : name));
  const refunds = toNames(stack.refundsIn, REFUND_PLATFORM_LABELS, stack.refundsOtherName);
  return [
    ...toNames(stack.crms, CRM_LABELS, stack.otherCrmName),
    ...apps,
    ...toNames(stack.helpdesks, HELPDESK_LABELS, stack.otherHelpdeskName),
    ...(refunds.length ? [`refunds in ${refunds.join(", ")}`] : []),
  ].join(" · ");
}
